import React from 'react';
import { Modal, Button } from 'react-bootstrap';

import ModalCloseButton from './ModalCloseButton';

const DefaultModal = ({ open, setOpen, title = "Modal", children, footer }) => {
    const closeModal = () => {
        setOpen(false);
    }

    return (
        <Modal show={open} onHide={closeModal}>
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
                <ModalCloseButton onClick={closeModal} />
            </Modal.Header>
            <Modal.Body>
                { children }
            </Modal.Body>
            <Modal.Footer>
                {footer && (
                    <>
                        <Button variant="dark" onClick={closeModal}>Abbrechen</Button>
                        {footer}
                    </>
                )}
                {!footer && <Button variant="dark" onClick={closeModal}>Schließen</Button>}
            </Modal.Footer>
           
        </Modal>
    )
};

export default DefaultModal;